import { Stack } from '@mui/material';
import * as refine from '@refinedev/core';
import { Create, Edit } from '@refinedev/mui';
import { useMemo } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { BaseField } from '../../../components/fields/BaseField.tsx';
import { Series } from '../../../types/index.ts';

const COMPONENT_MAP = { create: Create, edit: Edit } as const;

export const SeriesForm = ({ action }: { action: 'create' | 'edit' }) => {
  const { query, formLoading, onFinish } = refine.useForm<Series>({
    resource: 'contents/series',
    action,
  });

  const data = useMemo(
    () => (query?.data?.data ? Series.parse(query?.data?.data) : undefined),
    [query?.data?.data],
  );

  const methods = useForm<Series>({
    values: data,
  });

  const Component = COMPONENT_MAP[action];

  return (
    <Component
      canDelete
      isLoading={formLoading}
      saveButtonProps={{
        disabled: methods.formState.isSubmitting || formLoading,
        onClick: methods.handleSubmit(onFinish),
      }}
    >
      <FormProvider {...methods}>
        <Stack spacing={2}>
          <BaseField
            name="name"
            rules={{
              required: '必須',
            }}
            label="名称"
            fullWidth
          />
        </Stack>
      </FormProvider>
    </Component>
  );
};
